<template>
  <!-- star -->
  <div class="homepage_wrap">
    <TechTitle></TechTitle>
    <!--    :banner-h="banenrH1"-->
    <!--    <Banner :banner-h="$t('home.banner.title')" :banner-title-style="bannerTitleStyle" :banner-img="'none'"-->
    <!--            :banner-p="bannerP"-->
    <!--            :style-height="styleHeight" :text-style="textStyle" :text-content-style="textContentStyle"></Banner>-->

    <!--  提供服务版型 -->
<!--    <section class="provisionOfServices">-->
<!--      <scroll-animate>-->
<!--        <ul class="provisionOfServicesItems">-->
<!--          &lt;!&ndash;        <li class="provisionOfServicesItem wow animate__animated animate__fadeInUp">&ndash;&gt;-->
<!--          &lt;!&ndash;          <h1>{{ $t('home.solutions.title') }}</h1>&ndash;&gt;-->
<!--          &lt;!&ndash;        </li>&ndash;&gt;-->
<!--          <li class="provisionOfServicesItem" v-for="(item,index) in solutionData"-->
<!--              :key="index" @click="clickContact(item)">-->
<!--            <div class="provisionOfServicesItemBox">-->
<!--              <div class="provisionOfServicesItemBoxContent">-->
<!--                <img :src="item.image" :alt="$t(item.i18nTitleKey)" v-if="item.video==null">-->
<!--                <video-->
<!--                    src="@/assets/video/glassDoorHandleSmartLock.mp4"-->
<!--                    autoplay-->
<!--                    loop-->
<!--                    muted-->
<!--                    controlslist="nofullscreen nodownload noremoteplayback"-->
<!--                    @contextmenu.prevent-->
<!--                    v-if="item.image==null">-->
<!--                </video>-->
<!--                <div class="provisionOfServicesItemBoxContentRightText">-->
<!--                  <h1>{{ $t(item.i18nTitleKey) }}</h1>-->
<!--                  <p>-->
<!--                    {{ $t(item.i18nContentKey) }}-->
<!--                  </p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </li>-->
<!--        </ul>-->

<!--      </scroll-animate>-->
<!--    </section>-->

    <!--  新提供服务  -->
    <section class="shanmai-services">
<!--      拉手锁-->
      <scroll-animate>
        <div class="shanmai-services-item">
          <div class="shanmai-service-item-title-content">
            <div class="shanmai-service-item-title">
              <h1>{{ $t('home.solutions.glassDoor.title') }}</h1>
            </div>
            <div class="shanmai-service-item-content">
              <p>{{ $t('home.solutions.glassDoor.content') }}</p>
            </div>
            <div class="shanmai-service-item-info">
              <span @click="clickContact(1)">{{$t('common.learnMore')}}</span>
            </div>
          </div>
          <div class="shanmai-services-item-img">
            <video
                src="@/assets/video/glassDoorHandleSmartLock.mp4"
                autoplay
                loop
                muted
                controlslist="nofullscreen nodownload noremoteplayback"
                @contextmenu.prevent>
            </video>
          </div>
        </div>
      </scroll-animate>
      <scroll-animate>
        <div class="shanmai-services-item">
          <div class="shanmai-service-item-title-content">
            <div class="shanmai-service-item-title">
              <h1>{{ $t('home.solutions.rfidTake.title') }}</h1>
            </div>
            <div class="shanmai-service-item-content">
              <p>{{ $t('home.solutions.rfidTake.content') }}</p>
            </div>
            <div class="shanmai-service-item-info">
              <span @click="clickContact(2)">{{$t('common.learnMore')}}</span>
            </div>
          </div>
          <div class="shanmai-services-item-img">
            <img src="@/assets/img/service/access/rfid/rfid_handheld_terminal.png">
          </div>
        </div>
      </scroll-animate>
      <scroll-animate>
        <div class="shanmai-services-item">
          <div class="shanmai-service-item-title-content">
            <div class="shanmai-service-item-title">
              <h1>{{ $t('home.solutions.accessControl.title') }}</h1>
            </div>
            <div class="shanmai-service-item-content">
              <p>{{ $t('home.solutions.accessControl.content') }}</p>
            </div>
            <div class="shanmai-service-item-info">
              <span @click="clickContact(3)">{{$t('common.learnMore')}}</span>
            </div>
          </div>
          <div class="shanmai-services-item-img">
            <img src="@/assets/img/index/fangan/index_jiejue1.png">
          </div>
        </div>
      </scroll-animate>
      <scroll-animate>
        <div class="shanmai-services-item">
          <div class="shanmai-service-item-title-content">
            <div class="shanmai-service-item-title">
              <h1>{{ $t('home.solutions.smartDisplay.title') }}</h1>
            </div>
            <div class="shanmai-service-item-content">
              <p>{{ $t('home.solutions.smartDisplay.content') }}</p>
            </div>
            <div class="shanmai-service-item-info">
              <span @click="clickContact(4)">{{$t('common.learnMore')}}</span>
            </div>
          </div>
          <div class="shanmai-services-item-img">
            <img src="@/assets/img/index/fangan/index_jiejue2.png">
          </div>
        </div>
      </scroll-animate>
      <scroll-animate>
        <div class="shanmai-services-item">
          <div class="shanmai-service-item-title-content">
            <div class="shanmai-service-item-title">
              <h1>{{ $t('home.solutions.smartLocker.title') }}</h1>
            </div>
            <div class="shanmai-service-item-content">
              <p>{{ $t('home.solutions.smartLocker.content') }}</p>
            </div>
            <div class="shanmai-service-item-info">
              <span @click="clickContact(5)">{{$t('common.learnMore')}}</span>
            </div>
          </div>
          <div class="shanmai-services-item-img">
            <img src="@/assets/img/index/fangan/index_jiejue3.png">
          </div>
        </div>
      </scroll-animate>
    </section>

    <!-- 业务分布 -->
    <!--    <div class="distributionOfBus core_box clearfix wow animate__animated animate__fadeInUp">-->
    <!--      <div class="distributionOfBus_b">-->
    <!--        <div class="distributionOfBus_left_img">-->
    <!--          &lt;!&ndash; 图片比例4:3 &ndash;&gt;-->
    <!--          <img src="@/assets/img/yewufushe.png">-->
    <!--        </div>-->
    <!--        <div class="distributionOfBus_right">-->
    <!--          <div class="distributionOfBus_right_text">-->
    <!--            <h2>{{ $t('home.businessCoverage.title') }}</h2>-->
    <!--            <p>-->
    <!--              {{ $t('home.businessCoverage.content') }}-->
    <!--            </p>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import $ from "jquery"
import Banner from "@/components/banner.vue";
import TechTitle from "../components/TechTitle.vue";
import ScrollAnimate from "../components/ScrollAnimate.vue";

export default {
  name: "index",
  components: {
    ScrollAnimate,
    Banner,
    TechTitle
  },
  data() {
    return {
      // banenrImg: require("@/assets/img/banner-bg/banner_lanyun.jpg"),
      banenrH1: this.$t('home.banner.title'),
      bannerP: this.$t('home.banner.description'),
      bannerTitleStyle: {
        color: "#fff",
      },
      styleHeight: {
        backgroundColor: 'rgba(255,255,255,.3)',
        height: '400px',
      },
      textStyle: {
        backgroundColor: "rgba( 64,113,231,.5)",
        borderRadius: '0px !important',
        width: '100%',
        height: '100%',
      },
      textContentStyle: {
        color: '#fff !important',
        fontSize: '1.5rem',
      },
      navList: [
        {title: this.$t('home.nav.home'), url: "/"},
        {title: this.$t('home.nav.qualification'), url: "/briefIntroduction"},
        {title: this.$t('home.nav.products'), url: "/product/entranceGuard"},
        {title: this.$t('home.nav.aftersales'), url: "/aftersales"},
        {title: this.$t('home.nav.contact'), url: "/contact"}
      ],
      // 解决方案
      solutionData: [
        {
          key: 3,
          i18nTitleKey: 'home.solutions.glassDoor.title',
          i18nContentKey: 'home.solutions.glassDoor.content',
          video: require("@/assets/video/glassDoorHandleSmartLock.mp4"),
        },
        // {
        //   key: 4,
        //   i18nTitleKey: 'home.solutions.smartBuilding.title',
        //   i18nContentKey: 'home.solutions.smartBuilding.content',
        //   image: require("@/assets/img/index/fangan/index_jiejue5.png"),
        // },
        {
          key: 5,
          i18nTitleKey: 'home.solutions.rfidTake.title',
          i18nContentKey: 'home.solutions.rfidTake.content',
          image: require("@/assets/img/service/access/rfid/rfid_handheld_terminal.png"),
        },
        {
          key: 0,
          i18nTitleKey: 'home.solutions.accessControl.title',
          i18nContentKey: 'home.solutions.accessControl.content',
          image: require("@/assets/img/index/fangan/index_jiejue1.png"),
        },
        {
          key: 1,
          i18nTitleKey: 'home.solutions.smartDisplay.title',
          i18nContentKey: 'home.solutions.smartDisplay.content',
          image: require("@/assets/img/index/fangan/index_jiejue2.png"),
        },
        {
          key: 2,
          i18nTitleKey: 'home.solutions.smartLocker.title',
          i18nContentKey: 'home.solutions.smartLocker.content',
          image: require("@/assets/img/index/fangan/index_jiejue3.png"),
        }
      ],
      data1: [
        // {class: "box_sc_ul_li", src: require("../assets/img/shichang/shichang6.png"), name: "医院", text: "文本5"},
        // {class: "box_sc_ul_li", src: require("../assets/img/shichang/shichang7.png"), name: "品牌门店", text: "文本5"},
        // {class: "box_sc_ul_li", src: require("../assets/img/shichang/shichang8.png"), name: "珠宝连锁", text: "文本5"},
      ],

      logoimg: require("@/assets/img/logo.png"),

    };
  },
  computed: {
    title() {
      return this.$store.state.title;
    },
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.$wow.init()
    // })
    // 市场应用动画效果
    $(function () {
      $(".box_sc ul li").hover(function () {
        $(this).addClass('on').siblings().removeClass('on');
      }, function () {
        $(this).removeClass('on')
      });
    })
  },
  methods: {
    funyuming(msg) {
      this.$router.push(msg);
    },
    funRouter() {
      this.$router.push("/product/entranceGuard");
    },
    funAfterSales() {
      this.$router.push("/aftersales");
    },
    // 了解解决方案的详情
    clickContact(key) {
      let name = null
      switch (key) {
        case 1:
          name = "glassDoorHandleSmartLockService"
          break
        case 2:
          name = "rfidTakeService"
          break
        case 3:
          name = "accessControlIntelligentSystemServices"
          break
        case 4:
          name = "smartDisplayCaseService"
          break
        case 5:
          name = "smartLockersService"
          break
      }

      if (name != null && name !== '') {
        this.$router.push({
          name
        })
      }
    }
  }
};

</script>
<style scoped lang="scss">
@import "@/assets/css/libiao.scss";

.product_hardware {
  width: 98%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 0;

  h1 {
    color: #003087;
    line-height: 2;
  }

  p {
    color: #363f45;
    font-size: 20px;
    text-align: center;
  }
}

.homepage_wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /*服务*/
  .shanmai-services {
    width: 100%;
    .shanmai-services-item {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 95%;
      height: 500px;
      margin: 3rem auto;
      background-color: #ffffff;
      border-radius: 15px;
      border: 1px solid #e5e5e5;
      overflow: hidden;
      //box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

      @media screen and (max-width: 1050px) {
        flex-direction: column-reverse;
        height: auto;
        max-width: 700px;
        padding: 15px 10px;
      }


      .shanmai-service-item-title-content {
        position: relative;
        width: 30%;
        height: 100%;

        @media screen and (max-width: 1400px) {
          width: 40%;
        }

        @media screen and (max-width: 1050px) {
          width: 100%;
          height: 60%;
        }


        .shanmai-service-item-title {
          color: #003087;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          padding: 15px 60px;
          width: 100%;
          height: 30%;


          h1 {
            font-size: 32px;
            line-height: 2;
            font-weight: bold;

            @media screen and (max-width: 1050px) {
              text-align: center;
              font-size: 24px;
            }
          }
        }

        .shanmai-service-item-content {
          width: 100%;
          height: 60%;
          padding: 15px 60px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;

          @media screen and (max-width: 1050px) {
            padding: 15px 30px;
          }

          p {
            font-size: 18px;
            line-height: 2;
            text-indent: 2rem;
            white-space: pre-wrap;
          }
        }

        .shanmai-service-item-info {
          width: 100%;
          height: 7%;
          text-align: right;
          color: #2b64ad;
          cursor: pointer;
          padding-right: 20px;

          span {
            &:hover {
              color: #003087;
            }

            @media screen and (max-width: 1050px) {
              font-size: 17px;
            }
          }

          @media screen and (max-width: 1050px) {
            text-align: center;
          }
        }
      }

      .shanmai-services-item-img {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 70%;
        height: 100%;
        border-left: 1px solid #e5e5e5;

        img {
          height: 70%;
          object-fit: cover;
          @media screen and (max-width: 1400px) {
            height: 50%;
          }
          @media screen and (max-width: 1050px) {
            height: auto;
            width: 100%;
          }
        }
        video {
          height: 95%;
          border-radius: 10px;
          @media screen and (max-width: 1050px) {
            height: 100%;
          }
          @media screen and (max-width: 1050px) {
            height: auto;
            width: 70%;
          }
        }

        @media screen and (max-width: 1400px) {
          width: 60%;
        }
        @media screen and (max-width: 1050px) {
          width: 100%;
          height: 40%;
          border-left: none;
          border-bottom: 1px solid #e5e5e5;
          padding: 5px 0;
        }
      }

    }
  }


  /* 提供服务新样式 */
  .provisionOfServices {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    //max-width: 1500px;
    margin-top: 5rem;

    .provisionOfServicesItems {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      padding-left: 7%;

      @media screen and (max-width: 1700px) {
        //justify-content: space-around;
      }

      .provisionOfServicesItem {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: 30%;
        //height: 25rem;
        list-style: none;
        //margin-top: 3rem;
        margin: .5rem;
        margin-top: 2rem;
        border-radius: 1rem;
        overflow: hidden;
        background-color: white;
        transition: all .2s ease-in-out;
        padding: 1rem .5rem;
        -webkit-tap-highlight-color: transparent;

        &:hover {
          box-shadow: 0 0 10px rgba(0, 0, 0, .2);
        }

        .provisionOfServicesItemBox {
          position: relative;

          .provisionOfServicesItemBoxContent {
            position: relative;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-around;
            align-items: center;

            img {
              max-width: 60%;
              height: 15rem;
              //object-fit: fill;
              object-fit: cover;
              border-radius: 1rem;
              @media screen and (max-width: 700px) {
                width: 100%;
              }
            }

            video {
              max-width: 60%;
              height: 15rem;
              //object-fit: fill;
              object-fit: cover;
              border-radius: 1rem;
              @media screen and (max-width: 700px) {
                width: 100%;
                margin-right: 0;
              }
            }

            .provisionOfServicesItemBoxContentRightText {
              width: 35%;

              @media screen and (max-width: 700px) {
                width: 100%;
                padding: 1rem 1rem;
                text-align: center;
              }

              h1 {
                color: #003087;
                line-height: 1;
                font-size: 2rem;
              }

              p {
                width: 100%;
                font-size: .9rem;
                font-weight: 400;
                line-height: 1.5;
                white-space: pre-wrap;
              }
            }


          }
        }

        //@media screen and (min-width: 700px) {
        //  &:hover .provisionOfServicesItemBoxContentRightTextBottom {
        //    opacity: 1 !important;
        //  }
        //}

        @media screen and (max-width: 1720px) {
          .provisionOfServicesItemBoxContent h1 {
            font-size: 1rem !important;
          }
          .provisionOfServicesItemBoxContent p {
            font-size: 0.7rem !important;
          }
        }

        @media screen and (max-width: 1700px) {
          .provisionOfServicesItemBoxContent img {
            height: 10rem !important;
          }
        }

        @media screen and (max-width: 1200px) {
          .provisionOfServicesItemBoxContent img {
            height: 8rem !important;
          }
        }

        @media screen and (max-width: 1000px) {
          width: 90%;
          .provisionOfServicesItemBoxContent img {
            height: 15rem !important;
          }
        }
      }
    }
  }

}


</style>
